import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Stack, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CardTitle from './CardTitle';
import CenteredSpinner from '../../../components/CenteredSpinner';
import MainCard from '../../../components/MainCard';
import DashboardServices from '../../../services/DashboardServices';
import localStorageService from '../../../services/localStorageService';
import WidgetCard from './WidgetCard';

const MetricCard = ({ title, value, note, badge, color }) => (
	<WidgetCard>
		<Stack direction="row" justifyContent="space-between" alignItems="flex-start">
			<Box>
				{/* Card title component (14px, bold) */}
				<CardTitle>{title}</CardTitle>
				<Typography variant="h3" sx={{ fontWeight: 700, mt: 1, color: color }}>
					{value}
				</Typography>
				{note && (
					<Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
						{note}
					</Typography>
				)}
			</Box>

			{badge && (
				<Box className="flex-column items-center " sx={{ bgcolor: '#eef3ff', borderRadius: 1, px: 1.5, py: 0.5, color: '#12263b' }}>
					<Typography variant="caption">{badge}</Typography>
                <Typography variant="caption">MoM</Typography>
				</Box>
			)}
		</Stack>

		{/* <IconButton
			size="small"
			sx={{
				position: 'absolute',
				right: 12,
				bottom: 12,
				bgcolor: '#fff',
				border: '1px solid rgba(0,0,0,0.08)',
				'&:hover': { bgcolor: '#fafafa' },
			}}
			aria-label="add"
		>
			<AddIcon fontSize="small" sx={{ color: '#3b3b3b' }} />
		</IconButton> */}
	</WidgetCard>
);

const OverView = () => {
	const theme = useTheme();
	const [loading, setLoading] = useState(true);
	const [overview, setOverview] = useState(null);

	useEffect(() => {
		let mounted = true;

		const load = async () => {
            setLoading(true);
            try {
                // Determine if we should include organization_id based on user roles
                const storedUser = await localStorageService?.getItem?.('user') ?? null;
                const roles = (storedUser?.roles) || (storedUser?.role) || storedUser?.rolesArray || [];
                const normalizedRoles = Array.isArray(roles) ? roles.map(r => String(r).toLowerCase()) : [];
				const targetRoles = ['organization admin', 'case officer', 'case manager', 'organization head', 'director cid', 'director ncpa', 'deputy director','oic','department head','team leader first respondent','call center officer mowca', 'counselling officer', 'legal officer'];
                const hasTargetRole = normalizedRoles.some(r => targetRoles.includes(r));

                const params = {};
                if (hasTargetRole) {
                    const orgId = storedUser?.employee?.organization_id ?? storedUser?.organization_id ?? storedUser?.org?.id ?? null;
                    if (orgId) params.organization_id = orgId;
                }

                const res = await DashboardServices.getDashboardOverview(params);
                const payload = res?.data ?? res;
                if (mounted) setOverview(payload);
            } catch (err) {
                console.error('Failed to load dashboard overview', err);
            } finally {
                if (mounted) setLoading(false);
            }
        };

		load();
		return () => {
			mounted = false;
		};
	}, []);

	//if (loading) return <CenteredSpinner />;

	const d = overview?.view?.data ?? overview?.data ?? overview ?? {};

	const totalOfficers = d.total_officers ?? d.totalOfficers ?? 0;
	const last30 = d.officers_last_30_days ?? d.officersLast30Days ?? 0;
	const mom = d.officers_mom_percentage ?? d.officersMomPercentage ?? null;
	const branches = d.total_branches ?? d.totalBranches ?? 0;
	const departments = d.total_departments ?? d.totalDepartments ?? 0;

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
				<MetricCard
					title="Total Officer Registered"
					value={totalOfficers}
					note={typeof last30 === 'number' ? `Last 30 days: ${last30}` : undefined}
					badge={mom != null ? `${mom}%` : undefined}
					color={theme.palette.primary.main}
				/>
			</Grid>

			<Grid size={{ lg: 3, md: 3, sm: 6, xs: 6 }}>
				<MetricCard title="Branches" value={branches} note="Total Branches" color={theme.palette.primary.main} />
			</Grid>

			<Grid size={{ lg: 3, md: 3, sm: 6, xs: 6 }}>
				<MetricCard title="Departments" value={departments} note="Total Dept." color={theme.palette.primary.main} />
			</Grid>
		</Grid>
	);
};

export default OverView;

